import { Icon } from '@/design-system/components/icons/Icon';
import { H6, TextBody, TextCaption } from '@/design-system/components/typography';
import { SxProp, View } from 'dripsy';
import React from 'react';
import { useTranslation } from 'react-i18next';
import LandingBPShadowMobile from '../../../../assets/svg/LandingBPShadowMobile.svg';
import { LandingItem } from '../landing/BillPaymentLandingWeb.component';
interface IProps {
  payment: LandingItem;
}

export const ItemPayment: React.FC<IProps> = (payment) => {
  const { container, viewImageWrapper, viewContent, textTitle, textDescription, textPlaceInstruction, viewPlaceInstructionWrapper } =
    styles;
  const { t } = useTranslation('global-bill-payment');
  return (
    <View sx={{ ...container }}>
      <View sx={viewImageWrapper}>
        <LandingBPShadowMobile height={'100%'} width={'100%'} preserveAspectRatio={'none'} />
      </View>
      <View sx={viewContent}>
        <View sx={{ flex: 1 }}>
          <H6 bold sx={textTitle}>
            {payment.payment.title}
          </H6>
          <TextBody sx={textDescription}>{payment.payment.description}</TextBody>
        </View>
        <View sx={viewPlaceInstructionWrapper}>
          <TextCaption sx={textPlaceInstruction}>{t('global-bill-payment::general.place-instruction')}</TextCaption>
          <Icon name="arrowRightCircle" width={20} height={20} color={'#DC9B32'} />
        </View>
      </View>
    </View>
  );
};

const styles: Record<string, SxProp> = {
  container: {
    width: 220,
    height: '$50',
    shadowColor: '#000000',
    shadowOffset: {
      width: 0,
      height: 2
    },
    shadowOpacity: 0.15,
    shadowRadius: 8,
    elevation: 5,
    borderRadius: 10,
    overflow: 'hidden'
  },
  viewImageWrapper: {
    position: 'absolute',
    left: '$0',
    top: '$0',
    right: '$0',
    bottom: '$0',
    zIndex: 0
  },
  viewContent: {
    flex: 1,
    width: '100%',
    padding: '$4'
  },
  textTitle: {
    mb: '$3',
    color: '$secondary'
  },
  textDescription: {
    mb: '$3'
  },
  textPlaceInstruction: {
    color: '#DC9B32',
    mr: 6
  },
  viewPlaceInstructionWrapper: {
    flexDirection: 'row',
    alignItems: 'center'
  }
};
